import {
  LegacyMKPAnalyticsEventData,
  ObjectActionEventProperties,
} from '../../analytics'
import { SegmentAnalyticsCall } from '../track-event'
import makeProductBaseProperties from './product-common'

export function transformLegacyViewItem(
  data: Extract<LegacyMKPAnalyticsEventData, { event: 'view_item' }>
): SegmentAnalyticsCall {
  const product = data.ecommerce.detail.products[0]
  const cartAffiliation = data.ecommerce.affiliation
  const currency = data.ecommerce.currencyCode

  const eventProperties: ObjectActionEventProperties['Product']['Viewed'] = {
    category: 'Ecommerce',
    label: 'product_viewed',
    cart_affiliation: cartAffiliation,
    ...makeProductBaseProperties(product),
    currency,
  }

  if (product.category) {
    eventProperties.category_path = product.category

    const maxCategoryLimit = 5
    product.category.split(' / ').forEach((category: string, index: number) => {
      if (index < maxCategoryLimit && category !== '') {
        const key = `category_${index + 1}` as const
        eventProperties[key] = category
      }
    })
  }

  return {
    method: 'track',
    parameters: ['Product Viewed', eventProperties],
  }
}
